import styled from 'styled-components';
import { getObjectWithSelector } from '../../../functions/objectFunctions/getObjectWithSelector';
import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import { useElements, useScene } from '../../../hooks';
import { LauncherElement } from '../../../types/launcherElement';
import { MultiColorInput } from '../inputs/MultiColorInput';
import { NumberInput } from '../inputs/NumberInput';
import { VisibilityInput } from '../inputs/VisibilityInput';
import { BorderBoxInputGroup } from './BorderBoxInputGroup';
import { BoxShadowInputGroup } from './BoxShadowInputGroup';
import { CornerBoxInputGroup } from './CornerBoxInputGroup';

export const ContainerInputGroup = ({
  variant,
  tab,
  pseudoclass,

  colorPickerExtended,
  setColorPickerExtended,
}: {
  variant?: string;
  tab?: string;
  pseudoclass?: string;

  colorPickerExtended?: boolean;
  setColorPickerExtended?: (newValue: boolean) => void;
}) => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });

  let selector: string = 'props.class';
  if (variant && tab) {
    selector = `props.class.variants.${variant}.${tab}`;
  }

  if (pseudoclass === 'none') pseudoclass = undefined;
  if (pseudoclass) {
    selector = `${selector}.&:${pseudoclass}`;
  }

  const styleObj = getObjectWithSelector(selectedElement, selector);

  const labelWidth = 100;

  return (
    <Container>
      {tab === 'false' && <VisibilityInput {...{ variant, tab }} />}
      <MultiColorInput
        id={`${lastSelectedElementID}-${variant}-background-${tab}-${pseudoclass}-input`}
        label="Background"
        value={styleObj?.background || styleObj?.backgroundColor}
        onChange={(inputValue: string | undefined) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.backgroundColor`]: undefined,
              [`${selector}.background`]: inputValue,
            })
          )
        }
        labelWidth={labelWidth}
        extended={colorPickerExtended}
        setExtended={setColorPickerExtended}
      />
      <NumberInput
        id={`${lastSelectedElementID}-${variant}-opacity-${tab}-${pseudoclass}-input`}
        label="Opacity"
        value={styleObj?.opacity ? Number(styleObj.opacity) : undefined}
        onChange={(inputValue) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.opacity`]: inputValue,
            })
          )
        }
        labelWidth={labelWidth}
      />
      <CornerBoxInputGroup {...{ variant, tab, pseudoclass }} />
      <BorderBoxInputGroup
        {...{
          variant,
          tab,
          pseudoclass,
          colorPickerExtended,
          setColorPickerExtended,
        }}
      />

      <Separator />

      <BoxShadowInputGroup
        {...{
          variant,
          tab,
          pseudoclass,
          colorPickerExtended,
          setColorPickerExtended,
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Separator = styled.div`
  width: 100%;
  height: 10px;
`;
